import React from 'react';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import {
    getCurrencyItemInterval,
    getConversionStatus,
    getStatus
} from '../../../../helpers/common';
import {
    getQuery
} from '../../../modules';
import helperColumns from '../../../DataComponent/helper';
import { I18nFormatter } from '../../../../utils/I18n/I18n';
import { getPath } from 'utils/Router';
import TreeGoalActions from '../../../TreeGoalActions/TreeGoalActions';


const history = (state) => state.postbackHistory.list;
const postbacks = (state) => state.postbacks.list.data;
const serverStore = (state) => state.serverStorage.store;

export const mainSelector = createSelector(
    history,
    postbacks,
    (historyData = [], postbacksData = []) => {
        let list = [];

        historyData.map((item) => {
            const isExist = postbacksData.findIndex((postback) =>  postback.id === item.postback_id) !== -1;
            const title = `(${item.postback_id}) ${item.postback_config.title}`;

            list.push({
                id: item.id,
                conversionPostback: isExist ? <Link to={getPath('editPostback', {id: item.postback_id})}>{title}</Link> : title,
                createdAt: I18nFormatter.fullDateTime(+item.created_at),
                updatedAt: I18nFormatter.fullDateTime(+item.updated_at),
                status: getStatus(item.status),
                locale: item.postback_config.locale,
                currency: item.postback_config.currency,
                goalActions: <TreeGoalActions data={[item.conversion]} nestingLevel={2} />,
                goalTitle: <TreeGoalActions data={[item.conversion]} />,
                conversionID: <Link to={getPath('conversion', {id: item.conversion.id})}>{item.conversion.id}</Link>,
                createdAtConversion: I18nFormatter.fullDateTime(+item.conversion.created_at),
                updatedAtConversion: I18nFormatter.fullDateTime(+item.conversion.created_at),
                conversionStatus: getConversionStatus(item.conversion_status),
                timeFromTrackToAction: I18nFormatter.fromDate(item.conversion.track.created_at, item.conversion.created_at),
                advCid: item.conversion.adv_cid,
                typeAction: item.conversion.action.type,
                saleSum: I18nFormatter.currency(item.conversion.commission.sale_sum.amount, item.conversion.commission.sale_sum.currency, true),
                publisherCreditPerLead: I18nFormatter.currency(item.conversion.commission.publisher_credit_per_lead.amount, item.conversion.commission.publisher_credit_per_lead.currency, true),
                publisherCreditPerSale: I18nFormatter.currency(item.conversion.commission.publisher_credit_per_sale.amount, item.conversion.commission.publisher_credit_per_sale.currency, true),
                createdAtTrack: I18nFormatter.fullDateTime(item.conversion.track.created_at),
                ip: item.conversion.track.request.ip,
                ...getQuery({...item.conversion.track.request.query}),
                sendAttempts: getSendAttempts(item.send_attempts || [])
            });
        });

        return list;
    }
);

export const getListPostbacks = createSelector(
    postbacks,
    (postbacksData = []) => {
        return postbacksData.map(item => {
            return {
                value: item.id,
                title: item.config.title
            };
        });
    }
);

export const getHeaderName = createSelector(
    serverStore,
    (serverStore) => {
        return helperColumns.getDate('postbackHistory');
    }
);

const getSendAttempts = (list) => {
    return list.map((item) => {
        return {
            date: getCurrencyItemInterval(item.dt),
            request: item.request,
            response: item.response
        };
    });
};
